export default {
    data: `{
   "theme":"",
   "title":"testVideo",
   "slides":[
      {
         "content":[
            {
               "type":"Background",
               "moods":[
                  
               ],
               "stroke":"#000000",
               "strokeWidth":1,
               "strokeOpacity":0,
               "fill":"#ffffff",
               "fillOpacity":1,
               "opacity":1,
               "uuid":"86732c5c-86cb-4e65-85b2-be8d4066ae24",
               "xlinkHref":"https://d3b76ijxom7qfl.cloudfront.net/cartoonist/video/proxy/places/creaza_italia_roma_010.mp4",
               "isVideo":true,
               "volume":0.5,
               "inPoint":0,
               "outPoint":4.752
            },
            {
               "type":"Video",
               "opacity":1,
               "rotation":0,
               "uuid":"47642270-7f94-4b29-a700-aa4b6ef440a3",
               "stroke":"#000000",
               "strokeWidth":1,
               "strokeOpacity":0,
               "x":100,
               "y":100,
               "width":300,
               "height":168.75,
               "horizontalFlip":1,
               "verticalFlip":1,
               "xlinkHref":"https://d3b76ijxom7qfl.cloudfront.net/cartoonist/video/proxy/places/creaza_italia_candelora_002.mp4",
               "duration":12.074667
            }
         ],
         "initialized":true,
         "time":4.752,
         "uuid":"5835b9f3-95e6-4d16-ba2b-aee2c169532c",
         "contentItemId":-1,
         "sound":"",
         "soundEffect":"",
         "soundVolume":0.5,
         "soundEffectVolume":0.5
      },
      {
         "content":[
            {
               "type":"Background",
               "xlinkHref":"https://d3b76ijxom7qfl.cloudfront.net/cartoonist/video/proxy/places/creaza_italia_carneval_003.mp4",
               "moods":[
                  
               ],
               "stroke":"#000000",
               "strokeWidth":1,
               "strokeOpacity":0,
               "fill":"#ffffff",
               "fillOpacity":1,
               "opacity":1,
               "uuid":"f3464649-0a89-4128-97db-79335d5a45ec",
               "isVideo":true,
               "volume":0.5,
               "inPoint":0,
               "outPoint":4.558
            },
            {
               "type":"Video",
               "opacity":1,
               "rotation":0,
               "uuid":"5e81adc1-2aa2-466b-bdfb-9314526a197f",
               "stroke":"#000000",
               "strokeWidth":1,
               "strokeOpacity":0,
               "x":100,
               "y":100,
               "width":300,
               "height":168.75,
               "horizontalFlip":1,
               "verticalFlip":1,
               "xlinkHref":"https://d3b76ijxom7qfl.cloudfront.net/cartoonist/video/proxy/places/creaza_italia_candelora_001.mp4",
               "duration":20.074667
            }
         ],
         "initialized":true,
         "time":4.558,
         "uuid":"bcbbd422-36f7-4ce2-8d78-9d8b3b2ac60d",
         "contentItemId":-1,
         "sound":"",
         "soundEffect":"",
         "soundVolume":0.5,
         "soundEffectVolume":0.5
      },
      {
         "content":[
            {
               "type":"Background",
               "xlinkHref":"https://d3b76ijxom7qfl.cloudfront.net/cartoonist/video/proxy/places/creaza_italia_candelora_007.mp4",
               "moods":[
                  
               ],
               "stroke":"#000000",
               "strokeWidth":1,
               "strokeOpacity":0,
               "fill":"#ffffff",
               "fillOpacity":1,
               "opacity":1,
               "uuid":"96d3eef0-6758-48a0-8586-80755c2e9f3e",
               "isVideo":true,
               "volume":0.5,
               "inPoint":0,
               "outPoint":4.266
            },
            {
               "type":"Video",
               "opacity":1,
               "rotation":0,
               "uuid":"20f86b3e-fb20-435e-9bff-ab4d6b414686",
               "stroke":"#000000",
               "strokeWidth":1,
               "strokeOpacity":0,
               "x":100,
               "y":100,
               "width":300,
               "height":168.75,
               "horizontalFlip":1,
               "verticalFlip":1,
               "xlinkHref":"https://d3b76ijxom7qfl.cloudfront.net/cartoonist/video/proxy/places/creaza_italia_catania_001.mp4",
               "duration":9.066667
            }
         ],
         "initialized":true,
         "time":4.266,
         "uuid":"30fecc9e-fc24-4ebd-97af-2ee96c1333a6",
         "contentItemId":-1,
         "sound":"",
         "soundEffect":"",
         "soundVolume":0.5,
         "soundEffectVolume":0.5
      }
   ],
   "currentFont":"Cabin",
   "currentFontSize":24,
   "audioEditor":{
      "zoomValue":4,
      "markerPosition":0,
      "trackMenu":-1,
      "timelines":[
         {
            "index":0,
            "volume":1,
            "audios":[
               
            ]
         },
         {
            "index":1,
            "volume":1,
            "audios":[
               
            ]
         },
         {
            "index":2,
            "volume":1,
            "audios":[
               
            ]
         }
      ]
   }
}`
};



/** WEBPACK FOOTER **
 ** ./docs/newProduction.js
 **/